"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var icons_1 = require("../../../icons");
var illustrationMap = __importStar(require("../../../illustrations/index"));
var layout_1 = require("../../layout");
var styles_1 = require("./styles");
var Text_1 = __importDefault(require("../../Text"));
var style_1 = require("../../../style");
var FeaturedIcon_1 = __importDefault(require("../FeaturedIcon"));
var getComponentEmptyState = function (props) { return (react_1.jsx(layout_1.Flex, { direction: "column", alignItems: "center", justifyContent: "center" },
    react_1.jsx(FeaturedIcon_1.default, { icon: icons_1.SearchSm, size: "lg", theme: "light-circle-outline", color: "Gray" }),
    react_1.jsx(layout_1.Flex, { direction: "column", alignItems: "center", justifyContent: "center", css: styles_1.componentLevelStyle.textContainer },
        react_1.jsx(Text_1.default.Body, { size: "md", weight: "semibold", color: style_1.DesignSystemThemeColor.Gray.DARK_4 }, props.title),
        react_1.jsx("span", { css: styles_1.componentLevelStyle.description },
            react_1.jsx(Text_1.default.Body, { css: styles_1.componentLevelStyle.description }, props.description))),
    props.children)); };
var getPageEmptyState = function (props) {
    var level = props.level;
    var Illustration = illustrationMap[level.illustration];
    var pageLevelStyle = styles_1.createPageLevelStyle(level.position);
    return typeof props.level === 'object' &&
        'position' in props.level &&
        props.level.position === 'left' ? (react_1.jsx(layout_1.Flex, { direction: "row", alignItems: "center", justifyContent: "center" },
        Illustration && react_1.jsx(Illustration, null),
        react_1.jsx(layout_1.Flex, { direction: "column", alignItems: "center", justifyContent: "center" },
            react_1.jsx(layout_1.Flex, { direction: "column", alignItems: "center", justifyContent: "center", css: pageLevelStyle.textContainer },
                react_1.jsx(Text_1.default.Body, { size: "xl", weight: "semibold", color: style_1.DesignSystemThemeColor.Gray.DARK_4 }, props.title),
                react_1.jsx("span", { css: pageLevelStyle.description },
                    react_1.jsx(Text_1.default.Body, { size: "md", css: pageLevelStyle.description }, props.description))),
            props.children))) : (react_1.jsx(layout_1.Flex, { direction: "column", alignItems: "center", justifyContent: "center" },
        Illustration && react_1.jsx(Illustration, null),
        react_1.jsx(layout_1.Flex, { direction: "column", alignItems: "center", justifyContent: "center", css: pageLevelStyle.textContainer },
            react_1.jsx(Text_1.default.Body, { size: "xl", weight: "semibold", color: style_1.DesignSystemThemeColor.Gray.DARK_4 }, props.title),
            react_1.jsx("span", { css: pageLevelStyle.description },
                react_1.jsx(Text_1.default.Body, { size: "md", css: pageLevelStyle.description }, props.description))),
        props.children));
};
var EmptyState = function (props) {
    return props.level === 'component' ? getComponentEmptyState(props) : getPageEmptyState(props);
};
exports.default = EmptyState;
